import { cva } from 'class-variance-authority';

export const resourceContainer = cva(
  [
    'dark flex max-w-[800px] flex-col items-center gap-8 rounded-lg border-[1.5px] border-solid border-primary-300 p-6 text-white sm:flex-row sm:gap-6 sm:p-8',
  ],
  {
    variants: {
      color: {
        green: ['bg-primary-50 text-primary-900'],
      },
    },
    defaultVariants: {
      color: 'green',
    },
  },
);
